import { type } from "jquery";

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-destination', {
        // built-in attributes
        title: 'Card',
        description: 'Custom Card',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            },
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            cta: {
                type: 'string',
                default: 'Otkrijte više'
            },

        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                title,
                description,
                cta,
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onCtaChange(cta) {
                setAttributes({cta: cta});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />

                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />

                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />

                        <p><strong>Description</strong></p>
                        <TextControl value={ description } onChange={ onDescriptionChange }></TextControl>
                        <br />

                        <p><strong>Cta</strong></p>
                        <TextControl value={ cta } onChange={ onCtaChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <a class="card destination-card">
                    <div class="card-img">
                        <img class="cover-image" src={ image } alt={ alt } />
                    </div>
                    <div class="card-body">
                        <div class="title-container">
                            <RichText 
                                key="editable" 
                                tagName="h4"
                                className="title"
                                placeholder="TITLE" 
                                value={ title }
                                onChange={ onTitleChange } />
                            <RichText 
                                key="editable" 
                                tagName="p"
                                className="description text-dark"
                                value={ description }
                                onChange={ onDescriptionChange } />
                        </div>
                        <div class="cta-btn">
                            <RichText 
                                key="editable" 
                                tagName="div"
                                className="text text-dark btn btn-waning"
                                value={ cta }
                                onChange={ onCtaChange } />
                        </div>
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                title,
                description,
                cta,
            } = attributes;

            return (
                <a href={ link } className={ "card destination-card"} style={{opacity:0}}>
                    <div className="card-img lozad cover-image" data-background-image={ image }>
                        <img className="lozad cover-image" data-src={ image } alt={ alt } />
                    </div>
                    <div className="card-body">
                        <div className="title-container">
                            <h5 className="title">
                                { title }
                            </h5>
                            <p className="description">
                                { description }
                            </p>
                        </div>
                        <div className="cta-btn">
                            <div className="cta-btn-content">
                                <div className="text">
                                    { cta }
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            );
        },
    });
}